import React, { useState } from "react";
import "../styles/Preguntas.css";

const Preguntas = () => {
  const [activeAccordion, setActiveAccordion] = useState("collapseOne");

  const toggleAccordion = (id) => {
    setActiveAccordion(activeAccordion === id ? null : id);
  };

  return (
    <div className="presentation-page pt-16">
      {/* Hero Section */}
      <header className="preguntas-hero-section">
        <div className="preguntas-hero-content">
          <div className="preguntas-hero-container">
            {/* Hero Card */}
            <div className="preguntas-hero-card">
              <div className="preguntas-hero-grid">
                <div className="preguntas-hero-left">
                  <h1 className="preguntas-hero-title">
                    <span className="preguntas-hero-title-gradient">Preguntas</span> Frecuentes
                  </h1>
                </div>
                <div className="preguntas-hero-right">
                  <p className="preguntas-hero-description">
                    Respuestas a las preguntas más frecuentes que nos hacen sobre sismos, la Red Sísmica y la actividad
                    sísmica en la región del Noroeste de México.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Preguntas Básicas Section */}
      <section className="preguntas-basicas-section">
        <div className="preguntas-basicas-container">
          <div className="preguntas-basicas-grid">
            <div className="preguntas-basicas-card">
              <div className="preguntas-basicas-content">
                <div className="preguntas-basicas-header">
                  <h2 className="preguntas-basicas-title">
                    <span className="preguntas-basicas-title-gradient">Conceptos</span> Básicos
                  </h2>
                  <p className="preguntas-basicas-subtitle">Información fundamental sobre sismos y sismología</p>
                </div>

                <div className="preguntas-basicas-items">
                  {/* ¿Qué es un Sismo? */}
                  <div className="preguntas-basicas-item">
                    <div className="preguntas-basicas-item-content">
                      <h3 className="preguntas-basicas-item-title">
                        ¿Qué es un <span className="preguntas-basicas-item-title-gradient">Sismo</span>?
                      </h3>
                      <p className="preguntas-basicas-item-description">
                        Un sismo o temblor es un movimiento vibratorio que se origina en el interior de la Tierra y se
                        propaga por ella en todas direcciones en forma de ondas.
                      </p>
                    </div>
                    <div className="preguntas-basicas-item-image">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/falla.gif`}
                        alt="Animación de falla geológica"
                        className="preguntas-basicas-item-img"
                      />
                    </div>
                  </div>

                  {/* ¿Qué es la Sismología? */}
                  <div className="preguntas-basicas-item reverse">
                    <div className="preguntas-basicas-item-image">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/La_Tierra.jpeg`}
                        alt="La Tierra"
                        className="preguntas-basicas-item-img"
                      />
                    </div>
                    <div className="preguntas-basicas-item-content">
                      <h3 className="preguntas-basicas-item-title">
                        ¿Qué es la <span className="preguntas-basicas-item-title-gradient">Sismología</span>?
                      </h3>
                      <p className="preguntas-basicas-item-description">
                        La sismología es la rama de la geofísica que estudia el fenómeno de los sismos que ocurren en
                        nuestro planeta Tierra. Sus principales objetivos son:
                      </p>
                      <ul className="preguntas-basicas-item-list">
                        <li>
                          El estudio de la propagación de las ondas sísmicas por el interior de la Tierra a fin de
                          conocer su estructura interna
                        </li>
                        <li>El estudio de las causas que dan origen a los sismos</li>
                        <li>La prevención de daños</li>
                      </ul>
                    </div>
                  </div>

                  {/* ¿Por qué ocurren los sismos? */}
                  <div className="preguntas-basicas-item">
                    <div className="preguntas-basicas-item-content">
                      <h3 className="preguntas-basicas-item-title">
                        <span className="preguntas-basicas-item-title-gradient">¿Por qué ocurren</span> los sismos?
                      </h3>
                      <p className="preguntas-basicas-item-description">
                        La causa de un temblor es la liberación súbita de energía dentro del interior de la Tierra por
                        un reacomodo de ésta. Este reacomodo se lleva a cabo mediante el movimiento relativo entre
                        placas tectónicas. Las zonas en donde se lleva a cabo este tipo de movimiento se conocen como
                        fallas geológicas (la falla de San Andrés es un ejemplo) y a los sismos producidos se les conoce
                        como sismos tectónicos.
                      </p>
                      <p className="preguntas-basicas-item-description">
                        No obstante existen otras causas que también producen sismos. Ejemplo de ello son los producidos
                        por el ascenso de magma hacia la superficie de la Tierra. Este tipo de sismos, denominados
                        volcánicos, nos pueden servir de aviso de una posible erupción volcánica.
                      </p>
                    </div>
                    <div className="preguntas-basicas-item-image">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/falla-de-san-andres.jpeg`}
                        alt="Falla de San Andrés"
                        className="preguntas-basicas-item-img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección Azul - Medición de Sismos */}
      <section className="preguntas-medicion-section">
        <div className="preguntas-medicion-container">
          <div className="preguntas-medicion-content">
            <div className="preguntas-medicion-grid">
              <div className="preguntas-medicion-image">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/img/sismograma-richter-1.png`}
                  alt="Sismograma Richter"
                  className="preguntas-medicion-img"
                />
              </div>
              <div className="preguntas-medicion-text">
                <h2 className="preguntas-medicion-title">¿Cómo se mide el tamaño de un temblor?</h2>
                <p className="preguntas-medicion-description">
                  En un principio el tamaño de un temblor se medía únicamente por los efectos y daños que éste producía
                  en un lugar determinado, a lo que se conoce como intensidad del sismo. La escala de intensidad más
                  utilizada es la de Mercalli modificada. Esta escala es útil para zonas en donde no existen
                  instrumentos que registren los movimientos símicos (sismógrafos).
                </p>
                <p className="preguntas-medicion-description">
                  Actualmente se usa la magnitud, la cual permite clasificar a los sismos con base en la amplitud de
                  onda máxima registrada por un sismógrafo. El concepto de magnitud de un temblor se fundamenta en que
                  la amplitud de las ondas sísmicas es una medida de la energía liberada en el foco (origen del
                  temblor).
                </p>
                <div className="preguntas-medicion-button">
                  <a
                    href="https://resnom.cicese.mx/sitio/images/Richter.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="preguntas-medicion-link"
                  >
                    Leer más
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Preguntas Regionales Section */}
      <section className="preguntas-regionales-section">
        <div className="preguntas-regionales-container">
          <div className="preguntas-regionales-grid">
            <div className="preguntas-regionales-card">
              <div className="preguntas-regionales-content">
                <div className="preguntas-regionales-header">
                  <h2 className="preguntas-regionales-title">
                    <span className="preguntas-regionales-title-gradient">Sismicidad</span> en Baja California
                  </h2>
                  <p className="preguntas-regionales-subtitle">
                    Información específica sobre la actividad sísmica en nuestra región
                  </p>
                </div>

                <div className="preguntas-regionales-items">
                  {/* ¿Por qué tiembla en Baja California? */}
                  <div className="preguntas-regionales-item">
                    <div className="preguntas-regionales-item-content">
                      <h3 className="preguntas-regionales-item-title">
                        <span className="preguntas-regionales-item-title-gradient">¿Por qué tiembla</span> en Baja
                        California?
                      </h3>
                      <p className="preguntas-regionales-item-description">
                        En Baja California tiembla debido a que el proceso de separación de la península respecto del
                        macizo continental es aún activo a lo largo del sistema de fallas conocidas como San
                        Andrés-Golfo de California. Se sabe que la península de Baja California es parte de la Placa del
                        Pacífico mientras que el resto del país (México) está ubicado en la Placa de Norteamérica.
                        Diversos estudios han demostrado que el movimiento relativo entre estas dos placas es de
                        aproximadamente 6 centímetros por año.
                      </p>
                    </div>
                    <div className="preguntas-regionales-item-image">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/placas.jpg`}
                        alt="Placas tectónicas"
                        className="preguntas-regionales-item-img"
                      />
                    </div>
                  </div>

                  {/* Fallas geológicas */}
                  <div className="preguntas-regionales-item reverse">
                    <div className="preguntas-regionales-item-image">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/fallas2020.jpg`}
                        alt="Fallas geológicas"
                        className="preguntas-regionales-item-img"
                      />
                    </div>
                    <div className="preguntas-regionales-item-content">
                      <h3 className="preguntas-regionales-item-title">
                        <span className="preguntas-regionales-item-title-gradient">
                          ¿Cuáles son las fallas geológicas
                        </span>{" "}
                        en el Norte Baja California?
                      </h3>
                      <p className="preguntas-regionales-item-description">
                        En la región noroeste de México existen varias fallas geológicas importantes a lo largo de las
                        cuales se concentra una gran cantidad de actividad sísmica. Entre estas fallas podemos mencionar
                        las siguientes:
                      </p>
                      <ul className="preguntas-regionales-item-list">
                        <li>
                          <strong>En la región del Golfo de California:</strong> la falla Boca del Golfo (F.B.G) y falla
                          Bahía
                        </li>
                        <li>
                          <strong>En la región del Valle de Mexicali:</strong> Sistema de fallas Imperial (F. Imp.) -
                          Cerro Prieto (F.C.P), falla Cucapá (F. Cuc), falla Laguna Salada (F.L.S.), falla Hidalgo (F.
                          Hid.), falla Indiviso (F. Ind.)
                        </li>
                        <li>
                          <strong>En las sierras Peninsulares de Baja California:</strong> falla Sierra Juárez (F.S.J),
                          falla San Pedro Mártir (F.S.P), zona de fallas San Miguel (F.S.M) - Vallecitos (F. Valle),
                          falla Tres Hermanos (F. 3H.) y falla Agua Blanca (F.A.B)
                        </li>
                        <li>
                          <strong>Frente a las costas de Baja California (Océano Pacífico):</strong> falla Coronado
                          Banks (F.C.), falla San Diego (F.S.D.), falla San Clemente (F.S.C), falla San Quintín (F.S.Q)
                          y falla Isla de Cedros (F.I.C)
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección Azul - Mitos y Realidades */}
      <section className="preguntas-mitos-section">
        <div className="preguntas-mitos-container">
          <div className="preguntas-mitos-content">
            <div className="preguntas-mitos-header">
              <h2 className="preguntas-mitos-title">Mitos y Realidades</h2>
            </div>

            <div className="preguntas-mitos-grid">
              <div className="preguntas-mitos-item">
                <h3 className="preguntas-mitos-item-title">Mito:</h3>
                <p className="preguntas-mitos-item-text">
                  La península de Baja California se va a separar del continente por la ocurrencia de un sismo grande
                  (terremoto).
                </p>
                <h3 className="preguntas-mitos-item-title">Realidad:</h3>
                <p className="preguntas-mitos-item-text">
                  <strong>FALSO.</strong> En la Tierra no se puede acumular la inmensa cantidad de energía necesaria
                  para que esta separación pudiera ocurrir en un solo temblor. No obstante, se sabe que la península
                  junto con la porción suroeste de California se mueven hacia el noroeste en un proceso de separación
                  muy lento, el cual tardará millones de años en completarse.
                </p>
              </div>

              <div className="preguntas-mitos-item">
                <h3 className="preguntas-mitos-item-title">Mito:</h3>
                <p className="preguntas-mitos-item-text">Las mareas terrestres pueden disparar sismos.</p>
                <h3 className="preguntas-mitos-item-title">Realidad:</h3>
                <p className="preguntas-mitos-item-text">
                  <strong>FALSO.</strong> Las mareas terrestres son producidas por la influencia gravitacional que
                  ejercen el Sol y la Luna sobre la Tierra en rotación. Los estudios más cuidadosos NO han encontrado
                  alguna correlación estadística entre la ocurrencia de los sismos y las mareas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Más Preguntas Section */}
      <section className="preguntas-accordion-section" id="mas-preguntas">
        <div className="preguntas-accordion-container">
          <div className="preguntas-accordion-grid">
            <div className="preguntas-accordion-card">
              <div className="preguntas-accordion-wrapper">
                <div className="preguntas-accordion-header">
                  <h2 className="preguntas-accordion-title">
                    Otras <span className="preguntas-accordion-title-gradient">Preguntas Frecuentes</span>
                  </h2>
                  <p className="preguntas-accordion-subtitle">
                    Información adicional sobre sismos y fenómenos relacionados
                  </p>
                </div>

                <div className="preguntas-accordion-items">
                  {/* Acordeón 1 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseOne" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseOne")}
                    >
                      <span>¿Qué son los movimientos oscilatorios y trepidatorios del suelo?</span>
                      <i className={`fas fa-${activeAccordion === "collapseOne" ? "minus" : "plus"}`}></i>
                    </button>
                    <div className={`preguntas-accordion-panel ${activeAccordion === "collapseOne" ? "active" : ""}`}>
                      <p>
                        Durante un temblor el suelo puede vibrar en forma vertical y en forma horizontal debido
                        principalmente al arribo de las ondas P y S radiadas por la fuente. Estos movimientos se conocen
                        popularmente como movimientos "trepidatorios" y "oscilatorios". Por ser la onda P la más rápida,
                        se sentirá primero un movimiento vertical, y a los pocos segundos un movimiento horizontal, al
                        arribo de la onda S.
                      </p>
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/OndasPyS.jpg`}
                        alt="Ondas P y S"
                        className="preguntas-accordion-image"
                      />
                    </div>
                  </div>

                  {/* Acordeón 2 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseTwo" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseTwo")}
                    >
                      <span>¿Dónde tiembla más?</span>
                      <i className={`fas fa-${activeAccordion === "collapseTwo" ? "minus" : "plus"}`}></i>
                    </button>
                    <div className={`preguntas-accordion-panel ${activeAccordion === "collapseTwo" ? "active" : ""}`}>
                      <p>
                        Aproximadamente el 85% de la actividad sísmica y volcánica mundial se genera en el Círculo de
                        Fuego. La cadena de volcanes que bordea al Océano Pacífico, por la costa occidental del
                        continente americano, desde Chile hasta Alaska (pasando por México y California), y por la costa
                        oriental del continente asiático, desde Alaska hasta Nueva Zelanda se conoce como el Círculo de
                        Fuego.
                      </p>
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/anillodefuego.gif`}
                        alt="Anillo de Fuego"
                        className="preguntas-accordion-image"
                      />
                    </div>
                  </div>

                  {/* Acordeón 3 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseThree" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseThree")}
                    >
                      <span>¿Cuál es el terremoto más grande de la historia?</span>
                      <i className={`fas fa-${activeAccordion === "collapseThree" ? "minus" : "plus"}`}></i>
                    </button>
                    <div className={`preguntas-accordion-panel ${activeAccordion === "collapseThree" ? "active" : ""}`}>
                      <p>
                        El mayor terremoto conocido, e instrumentalmente registrado, ocurrió el 22 de mayo de 1960 en la
                        porción sur de Chile con una magnitud de 9.5. Aún así, los chilenos tuvieron la buena fortuna de
                        que 30 minutos antes de ocurrir ese macro sismo haya ocurrido un "sismo precursor" de magnitud
                        menor que inquietó e hizo salir a la población a las calles.
                      </p>
                    </div>
                  </div>

                  {/* Acordeón 4 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseFour" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseFour")}
                    >
                      <span>¿Qué es un tsunami o maremoto?</span>
                      <i className={`fas fa-${activeAccordion === "collapseFour" ? "minus" : "plus"}`}></i>
                    </button>
                    <div className={`preguntas-accordion-panel ${activeAccordion === "collapseFour" ? "active" : ""}`}>
                      <p>
                        TSUNAMI es el nombre que se da a las gigantescas olas producidas por los terremotos que ocurren
                        por debajo o cerca de los océanos. Estos terremotos, al hacer que el fondo marino se desplace en
                        forma vertical, producen un movimiento violento de la masa de agua, generándose así el tsunami.
                      </p>
                      <p>
                        Si deseas conocer más sobre los tsunamis ingresa a la siguiente página:{" "}
                        <a href="http://www.cicese.edu.mx/tsunami/" target="_blank" rel="noopener noreferrer">
                          http://www.cicese.edu.mx/tsunami
                        </a>
                      </p>
                    </div>
                  </div>

                  {/* Acordeón 5 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseFive" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseFive")}
                    >
                      <span>¿Se va a separar la península de Baja California del continente?</span>
                      <i className={`fas fa-${activeAccordion === "collapseFive" ? "minus" : "plus"}`}></i>
                    </button>
                    <div className={`preguntas-accordion-panel ${activeAccordion === "collapseFive" ? "active" : ""}`}>
                      <p>
                        La península de Baja California está separándose lentamente del resto de nuestro continente. La
                        península es parte de la placa tectónica del Pacífico, mientras que el resto de México forma
                        parte de la placa Norteamericana. Estas placas se desplazan horizontalmente en sentidos
                        opuestos, de tal manera que la península de Baja California viaja en dirección noroeste con
                        respecto al resto del país a una velocidad promedio de 6 centímetros por año.
                      </p>
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/GPS.png`}
                        alt="GPS"
                        className="preguntas-accordion-image"
                      />
                      <p className="preguntas-accordion-source">
                        Imagen tomada de: https://www.unavco.org/instrumentation/networks/status/pbo
                      </p>
                    </div>
                  </div>

                  {/* Acordeón 6 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseSix" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseSix")}
                    >
                      <span>¿Cuántos sismos ocurren en el mundo cada año?</span>
                      <i className={`fas fa-${activeAccordion === "collapseSix" ? "minus" : "plus"}`}></i>
                    </button>
                    <div className={`preguntas-accordion-panel ${activeAccordion === "collapseSix" ? "active" : ""}`}>
                      <p>
                        Anualmente ocurren varios millones de sismos de diversas magnitudes en todo el mundo, aunque
                        solo los sismos de mayor magnitud son los que causan daños a la sociedad. Los sismos de
                        magnitudes pequeñas solo son detectados por equipos sismológicos de muy alta sensibilidad.
                      </p>
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/Lista-de-los-terremotos-mas-grandes-del-mundo-USGS.jpg`}
                        alt="Lista de terremotos más grandes"
                        className="preguntas-accordion-image"
                      />
                    </div>
                  </div>

                  {/* Acordeón 7 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseSeven" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseSeven")}
                    >
                      <span>¿La ocurrencia de muchos sismos pequeños ayuda a que no ocurran sismos grandes?</span>
                      <i className={`fas fa-${activeAccordion === "collapseSeven" ? "minus" : "plus"}`}></i>
                    </button>
                    <div className={`preguntas-accordion-panel ${activeAccordion === "collapseSeven" ? "active" : ""}`}>
                      <p>
                        <strong>No.</strong> La energía liberada en los eventos de magnitudes pequeñas es despreciable
                        si se le compara con la energía liberada por los grandes terremotos. En la tabla que se presenta
                        a continuación puede apreciarse claramente que al pasar de magnitud 4.0 a 5.0, por ejemplo, la
                        energía cambia por un factor de 32, mientras que al pasar de magnitud 4.0 a 6.0 el factor es de
                        1000.
                      </p>
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/ergios.jpg`}
                        alt="Ergios"
                        className="preguntas-accordion-image"
                      />
                    </div>
                  </div>

                  {/* Acordeón 8 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseEight" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseEight")}
                    >
                      <span>¿Existe alguna relación entre la ocurrencia de sismos y el clima?</span>
                      <i className={`fas fa-${activeAccordion === "collapseEight" ? "minus" : "plus"}`}></i>
                    </button>
                    <div className={`preguntas-accordion-panel ${activeAccordion === "collapseEight" ? "active" : ""}`}>
                      <p>
                        <strong>NO.</strong> El viento, las lluvias y los cambios de temperatura afectan solamente a la
                        superficie terrestre, mientras que los sismos se originan a varios kilómetros de profundidad.
                        Los sismos comúnmente ocurren durante cualquiera de las estaciones del año, bajo cualquier tipo
                        de clima y a cualquier hora del día.
                      </p>
                    </div>
                  </div>

                  {/* Acordeón 9 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseNine" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseNine")}
                    >
                      <span>¿Se pueden predecir los sismos?</span>
                      <i className={`fas fa-${activeAccordion === "collapseNine" ? "minus" : "plus"}`}></i>
                    </button>
                    <div className={`preguntas-accordion-panel ${activeAccordion === "collapseNine" ? "active" : ""}`}>
                      <p>
                        <strong>No.</strong> La predicción de sismos se considera como una meta lejana de la sismología,
                        para cuando se conozca más sobre el mecanismo de los sismos. Una predicción válida tendría que
                        especificar con una muy buena precisión la magnitud, la fecha y el lugar de ocurrencia del
                        terremoto, lo cual no ha sido posible hacerlo hasta el presente.
                      </p>
                    </div>
                  </div>

                  {/* Acordeón 10 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseTen" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseTen")}
                    >
                      <span>¿Qué son las zonas de quietud sísmica o brechas sísmicas?</span>
                      <i className={`fas fa-${activeAccordion === "collapseTen" ? "minus" : "plus"}`}></i>
                    </button>
                    <div className={`preguntas-accordion-panel ${activeAccordion === "collapseTen" ? "active" : ""}`}>
                      <p>
                        Actualmente puede pronosticar la ocurrencia de sismos en regiones sísmicas para las que ya ha
                        transcurrido un tiempo considerable desde la ocurrencia del último temblor destructivo. Los
                        grandes sismos no ocurren uniformemente en todo el mundo, sino más bien ocurren repetidamente en
                        ciertas regiones limitadas.
                      </p>
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/BrechaGuerrero.jpg`}
                        alt="Brecha Guerrero"
                        className="preguntas-accordion-image"
                      />
                      <p className="preguntas-accordion-source">Fuente: Instituto de geofísica de UNAM.</p>
                    </div>
                  </div>

                  {/* Acordeón 11 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseEleven" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseEleven")}
                    >
                      <span>¿Podemos causar sismos?</span>
                      <i className={`fas fa-${activeAccordion === "collapseEleven" ? "minus" : "plus"}`}></i>
                    </button>
                    <div
                      className={`preguntas-accordion-panel ${activeAccordion === "collapseEleven" ? "active" : ""}`}
                    >
                      <p>
                        <strong>Sí.</strong> Las actividades humanas pueden ser la causa directa o indirecta de la
                        ocurrencia de sismos. A través de la inyección de fluidos de deshecho en pozos profundos ó del
                        llenado de una presa. Tales actividades incrementan la deformación en las rocas de una zona de
                        actividad sísmica, acelerando así el deslizamiento de las rocas a lo largo de fallas
                        pre-existentes.
                      </p>
                    </div>
                  </div>

                  {/* Acordeón 12 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseTwelve" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseTwelve")}
                    >
                      <span>¿Ocurren más sismos ahora que en el pasado?</span>
                      <i className={`fas fa-${activeAccordion === "collapseTwelve" ? "minus" : "plus"}`}></i>
                    </button>
                    <div
                      className={`preguntas-accordion-panel ${activeAccordion === "collapseTwelve" ? "active" : ""}`}
                    >
                      <p>
                        <strong>No.</strong> Aparentemente ocurren más eventos sísmicos hoy en día. Sin embargo, la
                        explicación se debe a que cada día existen más instrumentos de detección sísmica instalados en
                        el mundo, lo cual permite localizar un mayor número de sismos cada vez. A diferencia de años
                        pasados, los actuales sistemas de comunicación contribuyen también a que estemos mejor
                        informados de la actividad sísmica que ocurre en cualquier región de nuestro planeta.
                      </p>
                    </div>
                  </div>

                  {/* Acordeón 13 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseThirteen" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseThirteen")}
                    >
                      <span>¿Hay actividad geotérmica en Baja California?</span>
                      <i className={`fas fa-${activeAccordion === "collapseThirteen" ? "minus" : "plus"}`}></i>
                    </button>
                    <div
                      className={`preguntas-accordion-panel ${activeAccordion === "collapseThirteen" ? "active" : ""}`}
                    >
                      <p>
                        ¿Sabía usted que en el Valle de Mexicali existe uno de los yacimientos geotérmicos más
                        importantes del mundo? Por su tamaño y capacidad generadora de corriente eléctrica, el Campo
                        Geotérmico de Cerro Prieto es considerado como el segundo campo geotérmico más importante en el
                        mundo. Aunque en nuestro país existen otras zonas con actividad geotérmica (Las Tres Virgenes,
                        en Baja California Sur, Los Humeros, en Puebla, Los Azufres, en Michoacán y el Ceboruco, en
                        Nayarit, entre otros), Cerro Prieto es por mucho el yacimiento más importante. Este campo opera
                        con una capacidad para generar corriente eléctrica de 620 Mega Watts, con la cual cubre
                        fácilmente las necesidades de la ciudad de Mexicali.
                      </p>
                    </div>
                  </div>

                  {/* Acordeón 14 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseFourteen" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseFourteen")}
                    >
                      <span>
                        ¿Por qué ocurren deslizamientos en la carretera Tijuana-Ensenada si no hay fallas activas?
                      </span>
                      <i className={`fas fa-${activeAccordion === "collapseFourteen" ? "minus" : "plus"}`}></i>
                    </button>
                    <div
                      className={`preguntas-accordion-panel ${activeAccordion === "collapseFourteen" ? "active" : ""}`}
                    >
                      <p>
                        ¿Sabía usted que los deslizamientos de terreno que ocurren en la carretera escénica
                        Tijuana-Ensenada -- en la vecindad de la caseta de cobro de San Miguel -- no son producidos por
                        fallas geológicas activas? Tales deslizamientos, como muchos otros en diversas partes del mundo,
                        se generan por inestabilidad del terreno, que cuando aumenta la carga por exceso de agua
                        atrapada, se produce lo que se conoce como un deslizamiento rotacional, sin estar asociado a la
                        ocurrencia de un temblor.
                      </p>
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/Deslizamiento.jpg`}
                        alt="Deslizamiento"
                        className="preguntas-accordion-image"
                      />
                      <p className="preguntas-accordion-source">Fuente: Cortesía M.C Alejandro Hinojosa.</p>
                    </div>
                  </div>

                  {/* Acordeón 15 */}
                  <div className="preguntas-accordion-item">
                    <button
                      className={`preguntas-accordion-button ${activeAccordion === "collapseFifteen" ? "active" : ""}`}
                      onClick={() => toggleAccordion("collapseFifteen")}
                    >
                      <span>¿Sabía que los sismos más fuertes cerca de Ensenada ocurrieron en los años 50?</span>
                      <i className={`fas fa-${activeAccordion === "collapseFifteen" ? "minus" : "plus"}`}></i>
                    </button>
                    <div
                      className={`preguntas-accordion-panel ${activeAccordion === "collapseFifteen" ? "active" : ""}`}
                    >
                      <p>
                        En los últimos 50 años, los sismos de mayor magnitud con epicentros en la vecindad de la ciudad
                        de Ensenada ocurrieron en 1954 y 1956. En esos años se originaron sismos con magnitudes hasta de
                        6.8 en asociación con la falla de San Miguel. La distancia entre Ensenada y los epicentros más
                        cercanos fue de entre 50 y 60 kilómetros.
                      </p>
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/SismEns.jpg`}
                        alt="Sismicidad Ensenada"
                        className="preguntas-accordion-image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Preguntas;
